import { createStore } from 'vuex'
import user from './modules/user'

// 根状态接口
export interface RootState {
  user: typeof user.state
}

// 创建Vuex store
const store = createStore<RootState>({
  modules: {
    user
  }
})

export default store
